import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    id: "annual-sale-modal",
    class: "modal min2 js-modal"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "pop" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "年商", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "　", -1);
const _hoisted_6 = ["value"];
const _hoisted_7 = {
    key: 0,
    class: "err"
};
const _hoisted_8 = { class: "bt_box clear" };
import { ref, onMounted } from 'vue';
import ImageFrame from '@component/ImageFrame.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AnnualSaleModal',
    props: {
        options: { default: [] },
        id: null,
        errors: null
    },
    emits: ['selected', 'cancel'],
    setup(__props, { expose, emit }) {
        const props = __props;
        const originValue = ref(null);
        const close = ref();
        // キャンセルボタン
        const onClickCancel = () => {
            var _a;
            originValue.value = (_a = props.id) !== null && _a !== void 0 ? _a : null;
            emit('cancel');
        };
        // OKボタン
        const onClickOk = () => {
            emit('selected', originValue.value);
        };
        const onCloseModal = () => {
            close.value.click();
        };
        onMounted(() => {
            var _a;
            originValue.value = (_a = props.id) !== null && _a !== void 0 ? _a : null;
        });
        expose({
            onCloseModal,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "modal-bg bt_modal_close",
                    onClick: onClickCancel
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "close_bt bt_modal_close",
                        onClick: onClickCancel
                    }, [
                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((originValue).value = $event)),
                            id: "sel_2",
                            class: "wmax"
                        }, [
                            _hoisted_5,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    value: option.id
                                }, _toDisplayString(option.name), 9, _hoisted_6));
                            }), 256))
                        ], 512), [
                            [_vModelSelect, originValue.value]
                        ]),
                        (props === null || props === void 0 ? void 0 : props.errors)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props === null || props === void 0 ? void 0 : props.errors), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_modal_close bt_clear",
                                        onClick: onClickCancel
                                    }, "キャンセル")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_ok",
                                        onClick: onClickOk
                                    }, "OK")
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "bt_modal_close",
                                ref_key: "close",
                                ref: close,
                                style: { "display": "none" }
                            }, null, 512)
                        ])
                    ])
                ])
            ]));
        };
    }
});
